export default "__VITE_ASSET__B7p58CL9__"